var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nuttrema-hi-john"},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm._markdown.renderInline(_vm.$t('label.hi_john_welcome_back', { name: _vm.$auth.user().first_name })))}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2dd7325e","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/label/nuttrema-hi-john.vue
// module id = 2992
// module chunks = 0